import React from 'react'
import { useSelector } from 'react-redux'
import NarrativeMap from './NarrativeMap'
import NewsScene from './NewsScene'
import InfoScene from './InfoScene'
import Pie from '../../charts/Pie'
import Bar from '../../charts/Bar'
import Photo from '../minigames/Photo'

export default ({ tags }) => {
  if (tags?.img) {
    return (
      <div className='flex justify-center'>
        <img
          className="object-contain pb-4 lg:pb-0 scene"
          style={{ maxHeight: 300 }}
          alt={tags.imgAlt}
          src={require(`../../../assets/img/narrative/${tags.img}`)}
        />
      </div>
    )
  } else if (tags?.minigame === 'photo') {
    console.log(tags)
    return <Photo img={tags.photoImg} caption={tags.caption} />
  } else if (tags?.map) {
    return <NarrativeMap tags={tags} />
  } else if (tags?.news) {
    return <NewsScene news={tags.news} />
  } else if (tags?.info) {
    return <InfoScene data={tags.info} />
  } else if (tags?.graph) {
    const graph = useSelector(state => state.game.currentNarrativeObject.graphs[`${tags.graphName}`])
    if (tags.graph === 'pie') {
      return <Pie object={graph} />
    } else {
      return <Bar object={graph} />
    }
  } else {
    return null
  }
}